/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateTime } from './DateTime';
export type ConfirmPaymentPayload = {
    paidAt: DateTime;
    paymentType: ConfirmPaymentPayload.paymentType;
    taxRate: number;
    price: number;
};
export namespace ConfirmPaymentPayload {
    export enum paymentType {
        ONLINE = 'online',
        CASH = 'cash',
        INVOICE = 'invoice',
    }
}

